import { DialogActions, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type DialogActionsButtonsProps = {
  isTrial?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DialogActionsButtons = ({
  onClose,
  onConfirm,
  isTrial = false,
}: DialogActionsButtonsProps) => (
  <DialogActions>
    <Button onClick={onClose} variant="outlined">
      <FormattedMessage id="subscriptionChangeDialog.cancel" defaultMessage="Zrušit" />
    </Button>
    <Button onClick={onConfirm} variant="contained" color="primary">
      {isTrial ? (
        <FormattedMessage
          id="subscriptionChangeDialog.confirmTrial"
          defaultMessage="Potvrdit změnu bez platby"
        />
      ) : (
        <FormattedMessage
          id="subscriptionChangeDialog.confirm"
          defaultMessage="Potvrdit a zaplatit"
        />
      )}
    </Button>
  </DialogActions>
);

export default DialogActionsButtons;
